/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NaturalLanguageEntity,
    NaturalLanguageEntityFromJSON,
    NaturalLanguageEntityFromJSONTyped,
    NaturalLanguageEntityToJSON,
} from './NaturalLanguageEntity';

/**
 * Google Natural Language API の エンティティ解析レスポンスデータ
 * @export
 * @interface NaturalLanguageAnalyzeEntitiesSuccessResponseData
 */
export interface NaturalLanguageAnalyzeEntitiesSuccessResponseData {
    /**
     * エンティティ一覧 (https://cloud.google.com/natural-language/docs/reference/rest/v1/Entity?hl=ja)
     * @type {Array<NaturalLanguageEntity>}
     * @memberof NaturalLanguageAnalyzeEntitiesSuccessResponseData
     */
    entities?: Array<NaturalLanguageEntity>;
}

export function NaturalLanguageAnalyzeEntitiesSuccessResponseDataFromJSON(json: any): NaturalLanguageAnalyzeEntitiesSuccessResponseData {
    return NaturalLanguageAnalyzeEntitiesSuccessResponseDataFromJSONTyped(json, false);
}

export function NaturalLanguageAnalyzeEntitiesSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalLanguageAnalyzeEntitiesSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entities': !exists(json, 'entities') ? undefined : ((json['entities'] as Array<any>).map(NaturalLanguageEntityFromJSON)),
    };
}

export function NaturalLanguageAnalyzeEntitiesSuccessResponseDataToJSON(value?: NaturalLanguageAnalyzeEntitiesSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entities': value.entities === undefined ? undefined : ((value.entities as Array<any>).map(NaturalLanguageEntityToJSON)),
    };
}

